import { DraftShiftInput, useSchedule } from './useSchedule'

type Input = Omit<
  DraftShiftInput,
  'date' | 'scheduleSlotId' | 'rowKey' | 'bookedCandidateId'
> & {
  rowKey?: number
  bookedCandidateId?: string
}

export const useEditShifts = (input: Input | undefined) => {
  const { onCreateDraftShift, onDeleteDraftShift, enableEditing } =
    useSchedule()

  const handleCreateDraftShift = (
    date: string,
    scheduleSlotId: string | undefined,
  ) => {
    if (!input) return
    onCreateDraftShift?.({
      ...input,
      date,
      scheduleSlotId,
      rowKey: input.rowKey,
      bookedCandidateId: input.bookedCandidateId,
    })
  }

  const handleDeleteDraftShift = (id: string) => onDeleteDraftShift?.(id)

  return {
    onCreateDraftShift: handleCreateDraftShift,
    onDeleteDraftShift: handleDeleteDraftShift,
    enableEditing,
  }
}
